<template>
  <time :datetime="date">
    {{ formattedDate }}
  </time>
</template>

<script lang="ts" setup>
import { format, getOptions } from '@/util/formatter/date';

const props = defineProps({
  date: {
    type: String,
    required: true,
  },
  showTime: {
    type: Boolean,
    default: true,
  },
  showYear: {
    type: Boolean,
    default: true,
  },
  showDate: {
    type: Boolean,
    default: true,
  },
  isUtcFormat: {
    type: Boolean,
    default: false,
  },
});

const formattedDate = computed(() => {
  return format(
    props.date,
    getOptions(
      props.showTime,
      props.showYear,
      props.showDate,
      props.isUtcFormat
    )
  );
});
</script>
